import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import './Navigation.css'

interface NavItem {
  path: string
  label: string
  adminOnly?: boolean
}

const navItems: NavItem[] = [
  { path: '/', label: 'Dashboard' },
  { path: '/log-event', label: 'Log Event' },
  { path: '/statistics', label: 'Statistics' },
  { path: '/trip-statistics', label: 'Trip Stats' },
  { path: '/trip-logs', label: 'Trip Logs' },
  { path: '/users', label: 'Users', adminOnly: true },
  { path: '/settings', label: 'Settings', adminOnly: true },
  { path: '/change-password', label: 'Change Password' },
]

// Main tabs for mobile (first 3 items)
const mainTabs = navItems.slice(0, 3)

export function Navigation() {
  const navigate = useNavigate()
  const { isAdmin } = useAuth()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = async () => {
    try {
      const response = await fetch('/api/auth/logout', {
        method: 'POST',
        credentials: 'include',
      })
      if (response.ok) {
        navigate('/login')
      }
    } catch (error) {
      console.error('Logout failed:', error)
      navigate('/login')
    }
  }

  const handleMenuItemClick = () => {
    setMenuOpen(false)
  }

  // Filter nav items based on user role
  const visibleNavItems = navItems.filter(item => !item.adminOnly || isAdmin)
  const visibleMenuItems = visibleNavItems.slice(3) // Items after the first 3

  return (
    <nav className="navigation">
      {/* Desktop navigation - all items visible */}
      <ul className="nav-list nav-list--desktop">
        {visibleNavItems.map((item) => (
          <li key={item.path} className="nav-item">
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `nav-link ${isActive ? 'nav-link--active' : ''}`
              }
              end={item.path === '/'}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
        <li className="nav-item nav-item--logout">
          <button onClick={handleLogout} className="nav-link nav-link--logout">
            Log out
          </button>
        </li>
      </ul>

      {/* Mobile navigation - tabs + burger menu */}
      <div className="nav-mobile">
        <ul className="nav-list nav-list--tabs">
          {mainTabs.map((item) => (
            <li key={item.path} className="nav-item">
              <NavLink
                to={item.path}
                className={({ isActive }) =>
                  `nav-link ${isActive ? 'nav-link--active' : ''}`
                }
                end={item.path === '/'}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <button
          className={`burger-menu ${menuOpen ? 'burger-menu--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span className="burger-line"></span>
          <span className="burger-line"></span>
          <span className="burger-line"></span>
        </button>

        {menuOpen && (
          <div className="menu-dropdown">
            <ul className="menu-dropdown-list">
              {visibleMenuItems.map((item) => (
                <li key={item.path}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `menu-dropdown-link ${isActive ? 'menu-dropdown-link--active' : ''}`
                    }
                    end={item.path === '/'}
                    onClick={handleMenuItemClick}
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
              <li>
                <button onClick={handleLogout} className="menu-dropdown-link menu-dropdown-link--logout">
                  Log out
                </button>
              </li>
            </ul>
          </div>
        )}
      </div>
    </nav>
  )
}
